<div class="dialog-container">
    <h2 mat-dialog-title>
        <div class="icon-wrapper">
            <i class="fa fa-money-bill-wave"></i>
        </div>
        Encaissement (F8)
    </h2>

    <div mat-dialog-content class="dialog-content">
        <p>Montant total en espèces dans le tiroir ?</p>

        <div class="form-group">
            <input type="number" [(ngModel)]="amount" (ngModelChange)="validateAmount()" (keydown)="onKeydown($event)"
                class="amount-input" placeholder="0" cdkFocusInitial>
            <span class="currency">MAD</span>
        </div>
    </div>

    <div mat-dialog-actions class="actions">
        <button mat-flat-button class="btn-cancel" (click)="onCancel()">
            Annuler
        </button>
        <button mat-flat-button class="btn-confirm" (click)="onConfirm()" [disabled]="!isValid">
            Valider
        </button>
    </div>
</div>